<div id="lnr-user-desktop-header">
  <div id="desktop-header-content">
    <div id="desktop-header-user-area">
      <div id="lnr-desktop-header-photo-area">
        <mat-icon *ngIf="!imgSource" id="lnr-desktop-header-photo-area-user" [matMenuTriggerFor]="userMenu.menu">account_circle</mat-icon>
        <img *ngIf="imgSource" id="lnr-desktop-header-photo" [matMenuTriggerFor]="userMenu.menu" src="{{imgSource}}" alt="{{alt}}">
      </div>
      <div id="header-info-area">
        <div class="name">{{ this.name }}</div>
        <div class="role">{{ this.labels.role }}</div>
      </div>
    </div>
    <div id="header-region">
      <div>{{ this.regions }}</div>
    </div>
  </div>
</div>
<app-profile-menu #userMenu [profileMenuItems]="profileMenuItems"></app-profile-menu>
